<template>
  <div class="container mt-4">
    <Loading v-if="!event"/>
    <div v-else>
      <div class="row mb-4">
        <div class="col-12">
          <h3 class="mb-4">{{ event.name }}<small class="ml-3 text-muted">Event</small></h3>
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item" v-if="event.parent_event"><router-link :to="{ name: 'Event', params: { id: event.parent_event._id }}">{{ event.parent_event.name }}</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">{{ event.name }}</li>
            </ol>
          </nav>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <h6 class="mb-3">Details</h6>
          <div class="row">
            <div class="col-4">Competition</div>
            <div class="col-8"><b>{{event.competition.name}}</b></div>
          </div>
          <div class="row">
            <div class="col-4">Sport</div>
            <div class="col-8"><b>{{event.competition.sport.name}}</b></div>
          </div>
          <div class="row">
            <div class="col-4">Start Date</div>
            <div class="col-8"><b>{{event.date_start | moment("DD/MM/YY HH:mm")}}</b></div>
          </div>
          <div class="row">
            <div class="col-4">End Date</div>
            <div class="col-8"><b>{{event.date_end | moment("DD/MM/YY HH:mm")}}</b></div>
          </div>
        </div>
        <div class="col-4">
          <h6 class="mb-3">Child Events</h6>
          <div class="list-group" v-if="event.child_events && event.child_events.length !== 0">
            <router-link v-for="event of event.child_events" :key="event._id" :to="{ name: 'Event', params: { id: event._id }}" class="list-group-item list-group-item-action">
              {{ event.name }}<br>
              <small>{{event.date_start | moment("DD/MM/YY HH:mm")}} <span v-if="event.date_end">➔ {{event.date_end | moment("DD/MM/YY HH:mm")}}</span></small>
            </router-link>
          </div>
          <div class="card" v-else>
            <div class="m-3 text-muted">
              No child events
            </div>
          </div>
          <router-link :to="{ name: 'EventAddWithParent', params: { parentid: event._id, competitionid: event.competition._id }}">
            <button class="btn btn-primary mt-4">Add child event</button>
          </router-link>
        </div>
        <div class="col-4">
          <h6 class="mb-3">Fixtures</h6>
          <div class="list-group" v-if="event.fixtures && event.fixtures.length !== 0">
            <router-link v-for="fixture of event.fixtures" :key="fixture._id" :to="{ name: 'Fixture', params: { id: fixture._id }}" class="list-group-item list-group-item-action">{{ fixture.name }}</router-link>
          </div>
          <div class="card" v-else>
            <div class="m-3 text-muted">
              No child events
            </div>
          </div>
          <router-link :to="{ name: 'FixtureAdd', params: { eventid: event._id }}">
            <button class="btn btn-primary mt-4">Add fixture to event</button>
          </router-link>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <hr class="mt-5">
          <router-link :to="{ name: 'EventEdit', params: { id: event._id }}"><button class="btn btn-warning mr-2">Edit</button></router-link>
          <button class="btn btn-danger" v-b-modal.delete-event-modal>Delete</button>
        </div>
      </div>
      <b-modal id="delete-event-modal" title="Warning: Event Deletion" :no-fade="true" @ok="deleteEvent">
        <div>
          <p>
            Proceed with <b>extreme</b> caution.
            <br>
            This will delete <b>all</b> child events and <b>all</b> linked fixtures.
            <br><br>
            If we count everything here, you'll delete <b class="text-danger">{{ countEvent }} child events</b> and <b class="text-danger">{{ countFixtures }} fixtures</b> linked. Be careful.
          </p>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import { eventService } from './../../services/event'
import { fixtureService } from './../../services/fixture'
import { fixtureTeamService } from './../../services/fixtureteam'

export default {
  name: 'Event',
  data () {
    return {
      event: null,
      countEvent: 0,
      eventIds: [],
      fixtureIds: [],
      fixtureTeamIds: [],
      countFixtures: 0
    }
  },
  mounted () {
    eventService.getOne(this.$route.params.id).then(result => {
      this.event = result.data.event
      this.countChildEvents(this.event)
    })
  },
  watch: {
    '$route.params.id': function (id) {
      eventService.getOne(id).then(result => {
        this.event = result.data.event
        this.eventIds = []
        this.fixtureIds = []
        this.fixtureTeamIds = []
        this.countEvent = 0
        this.countFixtures = 0
        this.countChildEvents(this.event)
      })
    }
  },
  methods: {
    countChildEvents (event) {
      this.eventIds.push(event._id)
      for (let fixture of event.fixtures) {
        this.fixtureIds.push(fixture._id)
        for (let fixtureTeam of fixture.fixtureteams) {
          this.fixtureTeamIds.push(fixtureTeam._id)
        }
      }
      if (event.child_events.length !== 0) {
        this.countEvent += event.child_events.length
        for (let eventInst of event.child_events) {
          this.countChildEvents(eventInst)
        }
      }
      this.countFixtures += event.fixtures.length
    },
    deleteEvent () {
      fixtureService.deleteMany(this.fixtureIds).then(resFixtures => {
        eventService.deleteMany(this.eventIds).then(resEvents => {
          fixtureTeamService.deleteMany(this.fixtureTeamIds).then(resFixtureTeams => {
            if (this.event.parent_event) {
              this.$router.push({ name: 'Event', params: { id: this.event.parent_event._id } })
            } else {
              this.$router.push({ name: 'Calendar' })
            }
          })
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Events/Event.vue